<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3">Settings for {{companyDetails.name}}</h1>
            <div class="py-2">

             <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom">
                <div class="col-md-6 col-sm-12">
                    <!-- <h3 class="h3">{{companyDetails.name}}</h3> -->

                </div>
                <div class="col-md-6 col-sm-12">
                    <div>
                        <a @click="creatStoreModal" class="btn btn-outline-primary float-right">Add a New Store</a>
                    </div>

                </div>
            </div>
            <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
            <h3 class="h3">Store settings</h3>
            <small>View and update your store details </small>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="float-right">
                    <button @click="saveCompanyDetails" class="btn btn-primary px-3">Save Changes</button>
                </div>
                </div>
                </div>
            <div class="container text-left mb-5">
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Company name <small class="text-danger">*</small></h6>
                        <small>
                            Appears on receipts, invoices, and more
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.name" :placeholder="companyDetails.name" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Avatar/Logo</h6>
                        <small>
                            Appears on receipts, invoices, and more
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="d-inline">
                            <img v-if="companyDetails.logo_url ===null" class="img-bordered rounded-circle" style="width: 50px; height: auto;" src="https://via.placeholder.com/510/FFFF00/000000?Text=duka" />
                            <img v-else class="img-bordered rounded-circle" :src="companyDetails.logo_url" style="width: 50px; height: auto;" />
                            <a v-b-modal.modal-3 title="Edit Company Profile" class="btn btn-outline-dark mx-2 rounded"> Choose </a><span>JPG, GIF or PNG. 1MB Max.</span>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Company Phone Number <small class="text-danger">*</small></h6>
                        <small>
                            Where customers can contact you for support. Appears on receipts and invoices.
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.phone" :placeholder="companyDetails.phone" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Email</h6>
                        <small>
                            Where customers can contact you for support. Appears on receipts and invoices.
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.email" :placeholder="companyDetails.email" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Country</h6>
                        <small>This will guide on currency. To be displayed </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <select class="form-control" v-model="companyDetails.companysettings.country">
                            <option value="null">Choose Country</option>
                            <option :value="{key,value}" v-for="(value,key) in countriesData" :key="value.country" >{{ value.country }}</option>
                        </select>
                     </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Address</h6>
                        <small>Where customers can contact you for support. Appears on receipts and invoices. </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.address" :placeholder="companyDetails.address" />
                    </div>
                </div>

                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Business Type</h6>
                        <small>The kind of business you do like restaurant, hardware etc </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.industry" :placeholder="companyDetails.industry" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">KRA Pin</h6>
                        <small>Your KRA PIN to help in filing of returns on verification this will appear on your receipts and invoice</small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.krapin" :placeholder="companyDetails.krapin" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">

                        <h6 class="py-1">Taxes and VAT <small class="text-danger">*</small></h6>
                        <small>
                             This will be added on every sale. <a href="/products">To update go to inventory and change for each item</a>
                         </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="companyDetails.companysettings.enable_taxes" id="all-taxes">
                            <label class="custom-control-label" for="all-taxes"><small>Enable Vat & other taxes</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Discounts <small class="text-danger">*</small></h6>
                        <small>
                             <a href="/products">To update go to inventory and change for each item</a>
                         </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="companyDetails.companysettings.enable_discounts" id="discounts">
                            <label class="custom-control-label" for="discounts"><small>Enable discount</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">KDS <small class="text-danger">*</small></h6>
                        <small>
                           This is applicable to restaurants that need to send orders to kitchen
                         </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="companyDetails.companysettings.has_kds" id="has_kds">
                            <label class="custom-control-label" for="has_kds"><small>Enable KDS </small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Reservations <small class="text-danger">*</small></h6>
                        <small>
                            This is for hotels which have rooms and booking spaces that need to be reserved
                         </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="companyDetails.companysettings.has_reservations" id="has_reservations">
                            <label class="custom-control-label" for="has_reservations"><small>Enable Reservations</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Appointments <small class="text-danger">*</small></h6>
                        <small>
                            To enable Appointments, this is for business that have appointments sessions, like saloons barbershops etc
                         </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="companyDetails.companysettings.has_appointments" id="has_appointments">
                            <label class="custom-control-label" for="has_appointments"><small>Enable discount</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Price change on the go <small class="text-danger">*</small></h6>
                        <small class="text-danger">
                             Allows one to change prices of items when making sales.
                         </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="companyDetails.companysettings.allows_price_change_on_the_go " id="price-change-on-the-go">
                            <label class="custom-control-label" for="price-change-on-the-go"><small>Enable Selling Price Change</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">User Pin <small class="text-danger">*</small></h6>
                        <small class="text-danger">
                             Employees can switch to another account on make sale page
                         </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="companyDetails.companysettings.users_pin_login" id="account-switch">
                            <label class="custom-control-label" for="account-switch"><small>Enable account switching</small></label>
                        </div>
                    </div>
                </div>

                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Other Details</h6>
                        <small>This will be added to bottom of receipt just before footer</small>
                        <small>You can state your terms,mode of payments etc</small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <textarea class="form-control" v-model="companyDetails.configs"></textarea>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Receipt footer</h6>
                        <small>This will be added to footer of receipt</small>
                        <small>Could be just a simple message</small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <textarea class="form-control" v-model="companyDetails.companysettings.receipt_footer_message"></textarea>
                    </div>
                </div>




            </div>
        </div>
        <b-modal ref="changeCompanyLogo" id="modal-3" hide-footer static>
            <h2 class="text-center text-dark py-2">Update Company Logo</h2>
            <form @submit.prevent="changeCompanyLogo">
                <fileuploader description="Max file size 2MB, only .png,jpeg allowed"></fileuploader>
                <b-button type="submit" variant="primary" class="btn-block my-2">Save Logo</b-button>
            </form>
        </b-modal>
        <b-modal ref="create-store-modal" id="modal-4" hide-footer hide-header static>
            <h2 class="text-center text-dark py-3">Add a new store</h2>

            <form @submit.prevent="createNewStore">
                <div class="form-group">
                    <label></label>
              <input class="form-control" type="text" placeholder="Store name" v-model="newStore.name" required/>

                </div>

              <div class="form-group">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="newStore.copyInventory" id="copyInventory">
                            <label class="custom-control-label" for="copyInventory"><small>Copy Inventory </small></label>
                        </div>
                        </div>
                        <div class="form-group">
                        <div v-if="newStore.copyInventory" class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="newStore.qtyToZero" id="qtyToZero">
                            <label class="custom-control-label" for="qtyToZero"><small>Copy Quantities </small></label>
                            <p><small>Copy Quantities as well</small></p>
                        </div>
                        </div>

                        <div class="form-group">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="newStore.switchToNew" id="switchToNew">
                            <label class="custom-control-label" for="switchToNew"><small>Switch to the new store</small></label>
                        </div>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-outline-primary">Create store</button>
                        </div>

            </form>
        </b-modal>
    </div>
</template>

<script>
import countriesJson from './countriesData.json';
import {mapGetters} from 'vuex'
    export default {
        name: "profile",
        data() {
            return {
                companyDetails: {
                    name: '',
                    email: '',
                    phone: '',
                    address: '',
                    krapin: '',
                    business_type: '',
                    town: '',
                    building: '',
                    street: '',
                    configs: '',


                    companysettings:{
                        enable_taxes:0,
                        enable_discounts:0,
                        country:null,
                    }
                },
                selectedBranch:0,
                companyBranches:[],
                newStore:{
                    name:'',
                    copyInventory:false,
                    copySettings:0,
                    switchToNew:1,
                    qtyToZero:false,
                    copyInventoryFrom:''
                },
                countriesData: countriesJson
            }
        },
        computed:{
            ...mapGetters(['userDetails']),

        },

        mounted() {
            this.getUserCompanyDetails()
            this.getCompanySettings()

        },
        methods: {
            createNewStore(e)
            {
                e.preventDefault()
                this.newStore.copyInventoryFrom = this.companyDetails.id;
                axios.post('/api/create-store',{...this.newStore}).then(results=>{

                    if(results.status === 200)
                    {
                        this.$refs['create-store-modal'].hide();
                        // if(this.newStore.switchToNew) {
                        //     // this.selectedBranch = results.data.id
                        //     window.location.reload()
                        // }
                    }
                }).catch(e=>{
                    console.log(e)
                })


            },
            async getCompanySettings()
            {
                try{
                    await axios.get('/api/settings')
                    .then(results=>{
                        this.companyDetails.companysettings = results.data
                    }).catch(errors => {

                    });
                }
                catch(e){
                    console.error(e)
                }

            },
            creatStoreModal()
            {
        const modalMessage = (this.userDetails.companybranches.length > 10) ? `You have exceeded branch limit. You currently have ${this.userDetails.companybranches.length} branches. Email sales@dukakit.com` : `You currently have ${this.userDetails.companybranches.length} branches. This will add an extra cost to your monthly billing`
        this.$bvModal.msgBoxConfirm(modalMessage, {
          title: (this.userDetails.companybranches.length > 10) ? "Limit reached." : "Confirm company branch creation",
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'No Skip',
          cancelTitle: 'Yes Create Branch !',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {

            if(value)
            {


            }
            else{
                if(this.userDetails.companybranches.length < 10)
                {
                    this.$refs['create-store-modal'].show()
                }

            }

          })
          .catch(err => {
            // An error occurred
          })

            },
            changeCompanyLogo() {

                let imagefilename = document.getElementById('filename').value;
                axios.post('/api/update-company-logo', {
                        companyId: this.companyDetails.id,
                        companyLogo: imagefilename
                    })
                    .then(result => {
                        this.$refs['changeCompanyLogo'].hide()
                        this.$toasts.push({
                            type: 'success',
                            message: result.data.message
                        })
                        this.companyDetails.logo_url = result.data.url
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            getUserCompanyDetails() {

                        this.companyDetails = this.userDetails.company


            },
            saveCompanyDetails() {
                axios.post('/api/settings/general', { ...this.companyDetails
                }).then(results => {
                    if(results.status===200)
                    {
                        this.$toasts.push({
                        type: 'success',
                        message: "Company details have updated"
                    })
                    window.location.reload()
                    }

                }).catch(errors => {
                })
            }
        },
    }
</script>

<style scoped>

</style>
